import PropTypes from 'prop-types';
import './Button.css';

export function Button({
  variant = 'secondary',
  size = 'md',
  disabled = false,
  type = 'button',
  onClick,
  children,
  className = '',
}) {
  return (
    <button
      type={type}
      className={`btn btn-${size} btn-${variant}${className ? ` ${className}` : ''}`}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

Button.propTypes = {
  variant: PropTypes.oneOf([
    'primary',
    'seal',
    'secondary',
    'ghost',
    'danger',
    'danger-solid',
  ]),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  onClick: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Button;
